import { ReactNode } from 'react';
import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';

type NavItem = {
  name: string;
  href: string;
};

type PageHeaderProps = {
  navList: NavItem[];
  title: string;
  label?: string;
  actions?: ReactNode;
};

export default function PageHeader({
  navList,
  title,
  label,
  actions,
}: PageHeaderProps) {
  return (
    <div>
      <Breadcrumbs navList={navList} />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div className="flex items-end">
          <Heading>{title}</Heading>
          {label && (
            <p className="mx-2 mb-1 text-sm font-bold text-zinc-500">{label}</p>
          )}
        </div>
        {actions && <div>{actions}</div>}
      </div>
    </div>
  );
}
